module.exports = __webpack_public_path__ + "static/media/received_1372512850107097 (1).86155f9a.jpeg";